/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignCompanyRequest
 */
export interface AssignCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof AssignCompanyRequest
     */
    companyKey: string;
}

/**
 * Check if a given object implements the AssignCompanyRequest interface.
 */
export function instanceOfAssignCompanyRequest(value: object): value is AssignCompanyRequest {
    if (!('companyKey' in value) || value['companyKey'] === undefined) return false;
    return true;
}

export function AssignCompanyRequestFromJSON(json: any): AssignCompanyRequest {
    return AssignCompanyRequestFromJSONTyped(json, false);
}

export function AssignCompanyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignCompanyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'companyKey': json['companyKey'],
    };
}

export function AssignCompanyRequestToJSON(json: any): AssignCompanyRequest {
    return AssignCompanyRequestToJSONTyped(json, false);
}

export function AssignCompanyRequestToJSONTyped(value?: AssignCompanyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyKey': value['companyKey'],
    };
}

